/**
 * Converst to Precision Amount
 * @param amount
 * @returns
 */

const toPrecisionAmount = (amount: number = 0): number => {
	const x = Number(amount.toFixed(4))

	return x
}

export default toPrecisionAmount
